import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {Result} from "../interfaces/result";
import {Configuration, Optimierung} from "../interfaces/configuration";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";

/**
 * Component with a comparism table of all visible configurations of the user.
 */
@Component({
  selector: 'app-photovoltaikcheck-ergebnis-compare',
  templateUrl: './ergebnis.compare.component.html',
  providers: []
})
export class ErgebnisCompareComponent implements OnInit, OnChanges {
  /**
   * prefix for the textkey
   */
  @Input() textkeyPrefix: string;

  /**
   * result of the current request
   */
  @Input() result: Result;

  /**
   * The users input and result.
   */
  @Input() anfrage: PhotovoltaikcheckAnfrage;

  /**
   * List of configurations that should be shown. Order of this list is important.
   */
  @Input() configurationTypes: Optimierung[];

  /**
   * currently selected configiration that we highlight for the user
   */
  @Input() currentConfigurationType: string;

  /**
   * Eventemitter if the height of the element changes
   */
  @Output() heightChange: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Indicates whether an element or component is hidden. Can be used to remove clickable elements
   *
   */
  @Input() isHidden: boolean = false;

  /**
   * data of all available systems for easier access in the template.
   */
  systems: {[key: string]: Configuration} = {};

  /**
   * extra textkeyprefix for this component
   */
  textkeyPrefixCompare: string;

  /**
   * prefix for configurations wth feedin
   */
  readonly OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG: string = PhotovoltaikcheckConstants.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG;

  /**
   * list of toggles to show/hide elements
   */
  toggle = {
    invest: false,
    balance: false,
    balance20: false
  };

  /**
   * should be show the invest toggle or not
   */
  showInvestToggle: boolean = true;

  /**
   * system uses credit
   */
  hasCredit: boolean = true;

  /**
   * user has own equity
   */
  hasEquity: boolean = true;

  /**
   * @inheritdoc
   */
  ngOnInit() {
    // textkeyprefix for this component
    this.textkeyPrefixCompare = this.textkeyPrefix + '.vergleich.';

    this.updateSystems();
  }

  /**
   * @inheritdoc
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if(changes.hasOwnProperty('result') && changes.result.isFirstChange() === false) {
      this.updateSystems();
    }
  }

  /**
   * Update locally saved systems
   */
  updateSystems(): void {
    // extract systems in another format
    this.showInvestToggle = false;
    this.hasEquity = false;
    this.hasCredit = false;

    this.result.result.data.photovoltaic_systems.forEach(configuration => {
      this.systems[configuration.optimierung] = configuration;

      // show some items
      if(configuration.finanzierung.foerderung_zuschuss?.summe > 0 || configuration.finanzierung.foerderung_kredit?.summe > 0) {
        this.showInvestToggle = true;
      }
      if(configuration.finanzierung.foerderung_kredit?.summe > 0) {
        this.hasCredit = true;
      }
    });

    // show own equity line
    if(this.anfrage.userInput.eigenkapital > 0) {
      this.hasEquity = true;
    }

    // set toggle for invest
    if(!this.showInvestToggle) {
      this.toggle.invest = false;
    }
  }

  /**
   * toggle one info section
   * @param info
   */
  toggleInfo(info: string): void {
    this.toggle[info] = !this.toggle[info];

    // let the outside world know about the change
    setTimeout(() => this.heightChange.emit());
  }
}
